import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../admin/api';
import { getSlotDefault } from '../data/assetSlots';

const AssetsContext = createContext(null);

export const AssetsProvider = ({ children }) => {
  const [overrides, setOverrides] = useState({}); // { slot_key: { url, media_id } }
  const apiBase = process.env.REACT_APP_BACKEND_URL;

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get('/api/assets');
      setOverrides(data || {});
    } catch (_) { /* keep defaults on failure */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <AssetsContext.Provider value={{ overrides, apiBase, refresh }}>
      {children}
    </AssetsContext.Provider>
  );
};

/**
 * Returns the active URL for a slot — the override if any, otherwise the
 * provided fallback or the registry default.
 */
export const useAsset = (slotKey, fallback) => {
  const ctx = useContext(AssetsContext);
  if (!ctx) return fallback || getSlotDefault(slotKey) || '';
  const ov = ctx.overrides[slotKey];
  if (ov) return `${ctx.apiBase}${ov.url}`;
  return fallback || getSlotDefault(slotKey) || '';
};

export const useAssets = () => {
  const ctx = useContext(AssetsContext);
  if (!ctx) throw new Error('useAssets must be used inside <AssetsProvider>');
  return ctx;
};
